import { type MouseEvent } from "react";

import { Box, SxProps, Typography } from "@mui/material";

import { schemeSx } from "@/src/theme/schemeStyles";

interface FooterLinkProps {
  text: string;
  href?: string;
  onClick?: (event: MouseEvent) => void;
  sx?: SxProps;
  newTab?: boolean;
}

const FooterLink = ({ text, href, newTab, onClick, sx }: FooterLinkProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <Box
      component="div"
      sx={{
        display: "block",
        mb: 0.5,
        ...sx
      }}
    >
      <Typography
        component="a"
        variant="body1"
        href={href ?? "#"}
        target={href && newTab ? "_blank" : undefined}
        rel={href && newTab ? "noopener noreferrer" : "noreferrer"}
        onClick={handleClick}
        // White on the light mode footer's dark gradient, Text/Primary on the
        // dark mode page surface.
        sx={schemeSx((muiTheme) => {
          const color = muiTheme.vars.palette.common.white;
          const darkColor = muiTheme.vars.palette.text.primary;

          return {
            color,
            textDecoration: "none",
            cursor: "pointer",
            display: "inline-block",
            "&:hover, &:focus, &:visited": {
              color,
              textDecoration: "underline"
            },
            ...muiTheme.applyStyles("dark", {
              color: darkColor,
              "&:hover, &:focus, &:visited": { color: darkColor }
            })
          };
        })}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default FooterLink;
